let UTILS = require("../libs/utils.js");
var v7784;
var v7785;
var config = require("../config.js");
module.exports = {
  id: "bhffa",
  name: "Bighead FFA",
  alias: "bhffa",
  leaderStats: ["score", "kills", "deaths"],
  party: true,
  tag: ["Party", "#ffac00", "#ffb600"],
  bighead: true,
  headMlt: 0.1,
  headMltMax: 3,
  onKill: function (game, p9312, p9313, p9314) {
    if (p9314 && p9314 != p9313) {
      p9314.headMlt = Math.min(this.headMltMax || 3, 1 + (this.headMlt || 0.1) * p9314.kills);
      game.players.updateHeadSize(p9314, p9314.headMlt);
      game.broadcast("bh", p9314.sid, p9314.headMlt);
    }
  }
};